import { render, staticRenderFns } from "./BookingResourcesPage.vue?vue&type=template&id=f1b222c8&"
import script from "./BookingResourcesPage.vue?vue&type=script&lang=ts&"
export * from "./BookingResourcesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports